import { render, staticRenderFns } from "./CampoFormaPago.vue?vue&type=template&id=1e012b66"
import script from "./CampoFormaPago.vue?vue&type=script&lang=js"
export * from "./CampoFormaPago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports